export type GithubIssueStatus = 'open' | 'closed';

export enum GithubIssueStatusColor {
  OPEN = '#2DA44E',
  CLOSED = '#8250DF',
}
